import { z } from 'zod';

const HubInfoTypeEnum = z.enum(['loading', 'success', 'error']);
const ShowHubInfoTypeEnum = z.enum(['always', 'ORYX_Admin']);

export const HubInfoUpdateSchema = z.object({
  type: HubInfoTypeEnum,
  title: z.string(),
  message: z.string(),
  displayCondition: ShowHubInfoTypeEnum,
});

export type HubInfoUpdate = z.infer<typeof HubInfoUpdateSchema>;
